// extracted by mini-css-extract-plugin
module.exports = {"container":"e_3C","label":"e_4C","image":"e_5C","name":"e_6C","description":"e_7C","descriptionCollapsed":"e_8C","bottomLine":"e_9C","socialIcon":"e_-C"};